import {
  WARNING_LEVEL_FETCHING,
  WARNING_LEVEL_FAILED,
  WARNING_LEVEL_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case WARNING_LEVEL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case WARNING_LEVEL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case WARNING_LEVEL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
